<div
  class="btn btn-primary add-btn-container custom-center"
  (click)="executeFx()"
>
  <div class="text-container">
    <p id="add-btn-text" class="add-btn-text">{{text}}</p>
  </div>
  <i class="pi pi-plus"></i>
  <div  class="circle pulse orange"></div>

</div>

